// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantProfileTabs-moduleattentionDot__ZuX27";
var _2 = "RentalPortalApplicantProfileTabs-moduleskeleton__vAjqo Skeleton-moduleSkeleton__Mlrfv";
var _3 = "RentalPortalApplicantProfileTabs-moduletabIcon__Tc01s";
var _4 = "RentalPortalApplicantProfileTabs-moduletabsWrapper__G5Ucp TabScrollList-modulewrapper__zIrvw";
export { _1 as "attentionDot", _2 as "skeleton", _3 as "tabIcon", _4 as "tabsWrapper" }
